import usePaywall from '../components/dashboard/paywall/usePaywall';
import useQueryParams from '../navigation-utils/useQueryParams';
import { useRunOnceWhenTruthy } from '../components/common/useRunOnceWhenTruthy';
import {
  ACTIVATE_TRIAL_COOKIE_NAME,
  ACTIVATE_TRIAL_QUERY_PARAM,
} from '../components/dashboard/paywall/paywallConsts';
import { useCookies } from 'react-cookie';
import { setUserSignUpSource } from '../services/mixpanel';
import useSweepNavigate from '../navigation-utils/useSweepNavigate';
import { ActionPaywallSource, PaywallState } from '../components/dashboard/paywall/paywallTypes';


const useAutoActivateTrial = () => {
  const { startTrial, paywallState } = usePaywall();
  const [cookies, , removeCookie] = useCookies();
  const query = useQueryParams();
  const { removeQueryParams } = useSweepNavigate();

  const activateTrialCookie = cookies[ACTIVATE_TRIAL_COOKIE_NAME];
  const activateTrialQuery = query.has(ACTIVATE_TRIAL_QUERY_PARAM);
  const shouldActivateTrial = activateTrialQuery || activateTrialCookie;
  const canStartTrial = paywallState === PaywallState.PRE_TRIAL;

  useRunOnceWhenTruthy(() => {
    if (canStartTrial) {
      setUserSignUpSource('Sales');
      startTrial(ActionPaywallSource.AUTO);
    }
    //cleanup:
    removeCookie(ACTIVATE_TRIAL_COOKIE_NAME, { path: '/' });
    removeQueryParams([ACTIVATE_TRIAL_QUERY_PARAM]);
  }, shouldActivateTrial);
};

export default useAutoActivateTrial;
